import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-add-block',
  templateUrl: './add-block.component.html',
  styleUrls: ['./add-block.component.css']
})
export class AddBlockComponent {

  @Output() clicked = new EventEmitter<void>();

  constructor() { }

}
